import React from 'react';


const Star = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="16"
  >
    <path fill="#2E2F3A" d="M1.536 7c-.03 0-.06-.015-.09-.03a.162.162 0 01-.06-.161l.66-2.412-1.98-1.573c-.06-.03-.076-.103-.06-.162a.144.144 0 01.134-.103l2.552-.133.915-2.338c.03-.044.09-.088.15-.088s.12.044.135.088l.916 2.338 2.551.133c.06 0 .12.044.135.103a.164.164 0 01-.045.162L5.47 4.397l.66 2.412a.145.145 0 01-.06.162c-.045.029-.12.044-.165 0L3.757 5.618 1.611 6.97c-.03.03-.045.03-.075.03z" />
  </svg>
);

export default Star;
